<template>
	<div class="footer">
		<div style="background-color:#383d61" class="footer--bg"></div>
		<div class="footer--inner">
			<div class="am-g">
				<div class="am-u-md-3 ">
					<!-- <div class="footer_main--column">
						<strong class="footer_main--column_title">产品中心</strong>
						<ul class="footer_navigation">
							<li class="footer_navigation--item"><router-link to="/product" class="footer_navigation--link">家用电梯</router-link></li>
							<li class="footer_navigation--item"><router-link to="/product" class="footer_navigation--link">别墅电梯</router-link></li>
							<li class="footer_navigation--item"><router-link to="/product" class="footer_navigation--link">观光电梯</router-link></li>
						</ul>
					</div> -->
				</div>
				<div class="am-u-md-6 ">
					<div class="footer_main--column">
						<strong class="footer_main--column_title">关于我们</strong>
						<div class="footer_about">
							<p class="footer_about--text">
								湖南开旭网络科技有限公司是一家集软、硬为一体的解决方案服务商。
							</p>

							<p class="footer_about--text">备案号：<a target="_blank" href="https://beian.miit.gov.cn/">湘ICP备2021001201号</a></p>
						</div>
					</div>
				</div>
				<div class="am-u-md-3 ">
					<div class="footer_main--column">
						<strong class="footer_main--column_title">联系详情</strong>
						<ul class="footer_contact_info">
							<li class="footer_contact_info--item"><i class="am-icon-phone"></i><span>服务专线：0731-84435638</span></li>
							<li class="footer_contact_info--item"><i class="am-icon-map-marker"></i><span>湖南省长沙市天心区披塘村一力实业有限公司办公楼217</span></li>
							<li class="footer_contact_info--item"><i class="am-icon-clock-o"></i><span>周一 ~ 周五, 9:00 - 18:00 </span></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Footer"
}
</script>

<style scoped>

</style>
